








































































































































































import { Component, Vue } from "vue-property-decorator";
import { RelatorioAssociadosInativosModel } from "@/models/administracao/associados-inativos/RelatorioAssociadosInativosModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GerencialAssociadosInativosService from "@/service/relatorio/gerencial/GerencialAssociadosInativosService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { PaginationModel } from "@/models/commons/PaginationModel";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioAssocidosInativos extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };


  lista = [];
  tableHeader = [
    { text: 'Nome', value: 'nome', width: '15%' },
    { text: 'CPF / CNPJ', value: 'cpfCnpj', width: '15%'  },
    { text: 'Telefone', value: 'telefone', width: '15%' },
    { text: 'E-mail', value: 'email', width: '15%'  },
    { text: 'Frota', value: 'frota' },
    { text: 'Data Cadastro', value: 'dataCriacao'},
    { text: 'Endereço', value: 'endereco', width: '15%' },
    { text: 'Cidade', value: 'cidade'},
    { text: 'UF', value: 'estado'},
  ];
  tableOptions: PaginationModel = {
    itemsPerPage: 5,
    page: 1,
    itemsLength: 1,
  };

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;
  collapsibleOpened = false;

  relatorio: RelatorioAssociadosInativosModel = {
    inicio: undefined,
    fim: undefined,
  };


  getData() {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialAssociadosInativosService.buscarAssociadosInativos(this.relatorio)
          .then((res) => {
            this.loading = false;
            this.lista = res.data.registros;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        //this.limparformulario();
      }
    });
  }

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialAssociadosInativosService.gerarRelatorio(tipo, this.relatorio)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));

            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            fileLink.setAttribute(
              "download",
              `relatorio_associados_inativos.${
                tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

  public toggleCollapsible(): void {
    this.collapsibleOpened = !this.collapsibleOpened;
  }

  public limparformulario(): void {
    this.relatorio = {};
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
